import { Phone } from 'lucide-react';
import { useVoice } from '@/context/VoiceContext';
import { toast } from 'sonner';
import { normalizePhone as normalize } from '@/lib/phone';

/**
 * Reusable Click-to-Call button.
 * Usage: <ClickToCall number="+18635556666" name="John Doe" />
 */
export default function ClickToCall({ number, name, className = '' }) {
  const { requestDial, callStatus } = useVoice();

  if (!number) return null;

  const handleCall = (e) => {
    e.stopPropagation();
    if (callStatus !== 'idle') {
      toast.warning('Already on a call.');
      return;
    }
    requestDial(normalize(number), name || number, true);
  };

  return (
    <button
      data-testid={`click-to-call-${number.replace(/\D/g, '')}`}
      onClick={handleCall}
      title={`Call ${name || number}`}
      className={`
        inline-flex items-center justify-center w-7 h-7 rounded-full
        bg-emerald-50 text-emerald-600 hover:bg-emerald-100
        transition-all duration-150 flex-shrink-0 ${className}
      `}
    >
      <Phone className="w-3.5 h-3.5" strokeWidth={2.5} />
    </button>
  );
}
